<template>
	<div class="productstation">
		<!-- 加载中状态 -->
		<div v-if="loading" class="loading">加载中...</div>
		<!-- 接口数据：产品详情 HTML 渲染 -->
		<div v-else-if="productContent" class="imgbox" v-html="productContent"></div>
	</div>
</template>

<script>
	import global from '../common/global.js'
	
	export default {
		name: 'Productstation',
		data() {
			return {
				activename: '',
				chinese: '',
				loading: true,
				productContent: ''          // 接口返回的产品 HTML
			}
		},
		mounted() {
			this.activename = this.$route.query.globalname
			this.initData()
		},
		methods: {
			async initData() {
				// 1. 先从接口获取数据
				await this.getProductStation()
				this.loading = false
				
				if (!this.productContent) {
					// 2. 接口无数据时，用静态降级方案
					this.setChineseFromStatic()
				}
				
				// 设置页面标题
				document.title = this.chinese || '产品详情'
			},
			// 从接口获取产品站信息
			async getProductStation() {
				try {
					let res = await this.$Cloud
						.table(`lf_func_lefan_product`)
						.where({
							is_check: 2,
							product:this.activename
						})
						.get({
							page: 0,
							pageSize: 10
						})

					const { code, data } = res
					if (code == 200 && data && data.length > 0) {
						// 根据 globalname 匹配对应的产品
						let matched = data.filter(item => {
							// 尝试多种匹配方式
							return item.product == this.activename 
						})
						
						if (matched.length > 0) {
							let product = matched[0]
							// 优先使用 product_html（富文本内容）
							this.productContent = product.product_html
						}
					}
				} catch (e) {
					console.warn('获取接口数据失败', e)
				}
			}
		}
	}
</script>
<style>
	* {
		padding: 0;
		margin: 0;
	}

	.productstation {
		width: 65.5rem;
		margin: 0 auto;
		/* border: #000066 solid; */
	}

	.productstation .imgbox {
		width: 100%;
		margin: 0 a;
		font-size: 0;
		/* border: yellow solid; */
	}

	.productstation .imgbox img {
		width: 100%;
		/* border: #006600 solid; */
	}
</style>